module.exports = __webpack_public_path__ + "img/obi_slides.29d319e6.png";